import React from 'react';
import { SearchList } from '../view/search-list';
import { PubMedItem } from '../view/search-list/types';
import { fetchPubMedList, fetchPubMedSearch, fetchPubMedTabs } from '../view/search-list/queries';
import { Props } from '../types';

export const PubMed = ({ slot }: Props): JSX.Element => (
  <SearchList
    slot={slot}
    tabName="category"
    pageName="page"
    queryName="query"
    searchTabs={true}
    fetchTabs={fetchPubMedTabs}
    fetchList={fetchPubMedList}
    fetchSearch={fetchPubMedSearch}
  >
    {({ items }) => (
      <>
        {items && items.map((item : PubMedItem, index) => (
          <roche-teaser
            key={`${item.publishingDate}-${index}`}
            layout="teaser--pubmed"
            teaser-overline={item.parsedDate}
            teaser-title={item.title}
            teaser-author-description={item.authors.replace(/,(?! )/g, ', ')}
            teaser-description={item.description}
            teaser-url={item.externalLink}
            target="_blank"
          ></roche-teaser>
        ))}
      </>
    )}
  </SearchList>
);
